import { withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value", "placeholder", "minlength", "maxlength", "required", "aria-required", "data-fehlermeldung"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vorschlagsliste = _resolveComponent("vorschlagsliste")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      autocomplete: "chrome-off",
      type: "text",
      name: _ctx.name,
      value: _ctx.input,
      onFocusout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearUpdateVorschlag())),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateVorschlag(_ctx.inputChangeHandler($event), true))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateVorschlag(_ctx.inputChangeHandler($event), true))),
      onKeydown: [
        _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.akzeptiereVorschlag(undefined)), ["enter"])),
        _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.decVorschlag()), ["up"])),
        _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.incVorschlag()), ["down"])),
        _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.zeigeVorschlaege = false), ["tab"]))
      ],
      class: "c-form-control__input",
      "data-cy": "vorschlagcy",
      placeholder: _ctx.dropdowndaten.placeholder,
      minlength: _ctx.dropdowndaten.minlaenge,
      maxlength: _ctx.dropdowndaten.maxlaenge,
      required: _ctx.dropdowndaten.required,
      "aria-required": _ctx.dropdowndaten.required,
      "data-fehlermeldung": _ctx.dropdowndaten.fehlermeldung
    }, null, 40, _hoisted_1),
    _createVNode(_component_vorschlagsliste, {
      vorschlaege: _ctx.gefilterteVorschlaege,
      anzeigen: _ctx.zeigeVorschlaege,
      selected: _ctx.selectedVorschlag,
      onUpdate: _ctx.akzeptiereVorschlag
    }, null, 8, ["vorschlaege", "anzeigen", "selected", "onUpdate"])
  ], 64))
}